<style scoped="scoped" lang="scss">
// 新增工艺文档分析
.new-box {
  // 左侧
  .left {
    display: flex;
    align-items: center;

    .icon {
      display: inline-block;
      width: 5px;
      height: 16px;
      background: #419fff;
    }

    .txt {
      display: inline-block;
      font-weight: 400;
      font-size: 16px;
      color: #303133;
      margin-left: 12px;
    }
  }
}

.dialog /deep/ .el-dialog__body {
  overflow: auto;
}
</style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/manage/craft/guide/custom/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('gongyizhinanbianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gongyizhinanmingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wendangzhuangtai')">
            <el-select v-model="yt.conditions.status">
              <el-option :label="$t('xinjian')" :value="0"></el-option>
              <el-option :label="$t('yipizhun')" :value="1"></el-option>
              <el-option :label="$t('bohui')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <!--						<yi_cross_select multiple :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipmentId">-->
            <!--						</yi_cross_select>-->
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.modelId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.productId"> </yi_data_select>
            <!--						<yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.productId">-->
            <!--						</yi_cross_select>-->
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">
              {{ $t("chongzhi") }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzenggongyiwendang', null, 'w2')" type="primary" v-if="utils.checkPower('web_process_management_craft_create')">
          {{ $t("xinzeng") }}
        </el-button>
      </template>
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <!-- 新建 -->
        <template v-if="scope.row.status == 0">
          <el-button @click="approve(scope.row.id)" type="text">{{ $t("pizhun") }} </el-button>
          <el-button @click="turnDown(scope.row.id)" type="text" v-if="utils.checkPower('web_process_management_guide_reject')">{{ $t("bohui") }} </el-button>
          <el-button @click="yt.showEditDialog('bianji', scope.row, 'w2')" type="text" v-if="utils.checkPower('web_process_management_craft_update')">{{ $t("bianji") }} </el-button>
          <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/manage/craft/guide/delete')">
            {{ $t("shanchu") }}
          </el-button>
        </template>
        <!-- 已批准 -->
        <template v-else-if="scope.row.status == 1">
          <el-button @click="yt.showEditDialog('chakan', scope.row, '52%')" type="text">{{ $t("chakan") }} </el-button>
          <el-button @click="yt.showEditDialog('fuzhi', scope.row, 'w2')" type="text" v-if="utils.checkPower('web_process_management_guide_copy')">{{ $t("fuzhi") }} </el-button>
        </template>
        <!-- 驳回 -->
        <template v-else="scope.row.status == 2">
          <el-button @click="approve(scope.row.id)" type="text" v-if="utils.checkPower('web_process_management_guide_approve')">{{ $t("pizhun") }} </el-button>
          <el-button @click="yt.showEditDialog('bianji', scope.row, 'w2')" type="text">{{ $t("bianji") }} </el-button>
          <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/manage/craft/guide/delete')" v-if="utils.checkPower('web_process_management_craft_delete')">
            {{ $t("shanchu") }}
          </el-button>
        </template>
      </template>
    </yi_curd_table>
    <el-dialog class="dialog" :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增 工艺文档分析 -->
      <template v-if="yt.editObj.action == 'xinzenggongyiwendang'">
        <new_guide ref="new_guide" :formLabelWidth="yt.formLabelWidth" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" @click="saveGuide" type="primary" :loading="yt.editObj.loading">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!-- 编辑 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <edit_guide ref="edit_guide" :formLabelWidth="yt.formLabelWidth" :id="yt.editObj.id" :fileIds="yt.editObj.fileIds" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" @click="updateGuide" :loading="yt.editObj.loading" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!-- 复制 -->
      <template v-if="yt.editObj.action == 'fuzhi'">
        <cope_guide ref="cope_guide" :formLabelWidth="yt.formLabelWidth" :id="yt.editObj.id" :fileIds="yt.editObj.fileIds" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button size="mini" @click="updateCopy" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!--查看-->
      <template v-if="yt.editObj.action == 'chakan'">
        <detail_guide ref="detail_guide" :formLabelWidth="yt.formLabelWidth" :id="yt.editObj.id" :fileIds="yt.editObj.fileIds" />
      </template>
      <!-- 点检项 -->
      <template v-if="yt.editObj.action == 'xinjian'">
        <div class="dialog-scroller">
          <check_item :equipment="yt.editObj" ref="checkItem"></check_item>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini" @click="submitCheckItem(yt.editObj)" type="primary">
            {{ $t("提交") }}
          </el-button>
          <el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini" @click="yt.isShowEditDialog = false">{{ $t("取消") }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import new_guide from "./new_guide.vue";
import edit_guide from "./edit_guide.vue";
import cope_guide from "./cope_guide.vue";
import detail_guide from "./detail_guide.vue";

export default {
  name: "web_process_management_cloud_disk_list",
  components: {
    new_guide,
    edit_guide,
    cope_guide,
    detail_guide,
  },

  data() {
    return {
      leaveFactoryDate: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate(),
      list: [],
      equipmentList: [],
      columns: [
        {
          label: "gongyizhinanbianma",
          prop: "code",
        },
        {
          label: "gongyizhinanmingcheng",
          prop: "name",
        },
        {
          label: "wendangzhuangtai",
          type: "tag",
          prop: "status",
          tags: {
            0: {
              color: "#419FFF",
              text: this.$t("xinjian"),
            },
            1: {
              color: "#67C23A",
              text: this.$t("yipizhun"),
            },
            2: {
              color: "#E6A23C",
              text: this.$t("bohui"),
            },
          },
        },
        {
          label: "shebeiSN",
          prop: "equipment.sn",
          // type: "slot"
        },
        {
          label: "shebeimingcheng",
          prop: "equipment.name",
          // type: "slot"
        },
        {
          label: "mujubianhao",
          prop: "model.no",
        },
        {
          label: "mujumingcheng",
          // type: 'slot',
          prop: "model.name",
        },
        {
          label: "chanpinbianma",
          prop: "product.code",
        },
        {
          label: "chanpinmingcheng",
          prop: "product.name",
          // type: 'slot',
          width: 120,
        },
        {
          label: "gongyibanben",
          prop: "version",
          width: 80,
        },
        {
          label: "beizhu",
          prop: "remark",
        },
        {
          label: "chuangjianren",
          prop: "createByObject.nickname",
          width: 120,
        },
        {
          label: "chuangjianshijian",
          prop: "createTime",
          type: "time",
          width: 180,
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "shenpiren",
          prop: "checkUserObject.nickname",
          // type: 'slot',
          width: 120,
        },
        {
          label: "shenpishijian",
          prop: "updateTime",
          type: "time",
          width: 180,
          // type: 'slot',
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: "caozuo",
          type: "slot",
          width: 180,
          fixed: "right",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: "createTime desc",
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 保存
    saveGuide() {
      // // const res = [...this.$refs['new_guide'].form['craftGuideParams']]
      // // let obj = {}
      // // for (let i = 0; i < res.length; i++) {
      // //   this.$set(obj, res[i]['type'], res[i]['params'])
      // // }
      // console.log('ck', obj)

      console.log("vvvvv", this.$refs["new_guide"].form);
      this.$refs["new_guide"].$refs["form"].validate((valid) => {
        if (valid) {
          this.yt.editObj.loading = true;
          const params = {
            name: this.$refs["new_guide"].form["name"],
            equipmentId: this.$refs["new_guide"].form["equipmentId"],
            modelId: this.$refs["new_guide"].form["modelId"],
            productId: this.$refs["new_guide"].form["productId"],
            remark: this.$refs["new_guide"].form["remark"],
            fileIds: this.$refs["new_guide"].form["files"],
            // craftGuideParams: JSON.stringify(obj),
            craftGuideParams: [...this.$refs["new_guide"].form["craftGuideParams"]].map((item) => {
              return {
                equipmentId: item.equipmentId,
                params: item.params,
                name: item.name,
              };
            }),
          };
          // console.log('3333dddd',params)
          delete params["item3"];
          for (let i = 0; i < params["craftGuideParams"].length; i++) {
            params["craftGuideParams"][i]["params"] = JSON.stringify(params["craftGuideParams"][i]["params"]);
          }
          return this.http
            .post("/web/manage/craft/guide/create", params)
            .then((response) => {
              this.yt.isShowEditDialog = false;
              this.yt.get(1);
            })
            .catch((error) => {
              this.$message.error(error);
            })
            .finally(() => {
              this.yt.editObj.loading = false;
            });
        }
      });
    },
    // 更新
    updateGuide() {
      this.yt.editObj.loading = true;
      this.$refs["edit_guide"].$refs["form"]
        .validate((valid) => {
          if (valid) {
            const params = {
              id: this.$refs["edit_guide"].form["id"],
              name: this.$refs["edit_guide"].form["name"],
              equipmentId: this.$refs["edit_guide"].form["equipmentId"],
              modelId: this.$refs["edit_guide"].form["modelId"],
              productId: this.$refs["edit_guide"].form["productId"],
              remark: this.$refs["edit_guide"].form["remark"],
              fileIds: this.$refs["edit_guide"].form["files"],
              craftGuideParams: [...this.$refs["edit_guide"].form["craftGuideParams"]].map((item) => {
                return {
                  equipmentId: item.equipmentId,
                  params: item.params,
                  name: item.name,
                };
              }),
            };

            delete params["item3"];
            for (let i = 0; i < params["craftGuideParams"].length; i++) {
              params["craftGuideParams"][i]["params"] = JSON.stringify(params["craftGuideParams"][i]["params"]);
            }
            return this.http
              .post("/web/manage/craft/guide/update", params)
              .then((response) => {
                this.yt.isShowEditDialog = false;
                this.yt.get(1);
              })
              .catch((error) => {
                this.$message.error(error);
              });
          }
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    },
    // 复制
    updateCopy() {
      this.$refs["cope_guide"].$refs["form"].validate((valid) => {
        if (valid) {
          const params = {
            // id: this.$refs['cope_guide'].form['id'],
            name: this.$refs["cope_guide"].form["name"],
            equipmentId: this.$refs["cope_guide"].form["equipmentId"],
            modelId: this.$refs["cope_guide"].form["modelId"],
            productId: this.$refs["cope_guide"].form["productId"],
            remark: this.$refs["cope_guide"].form["remark"],
            fileIds: this.$refs["cope_guide"].form["files"],
          };
          if (this.$refs["cope_guide"].form["craftGuideParams"]) {
            const data = [...this.$refs["cope_guide"].form["craftGuideParams"]].map((item) => {
              return {
                equipmentId: item.equipmentId,
                params: item.params,
                name: item.name,
              };
            });
            params["craftGuideParams"] = data;
          }

          delete params["item3"];
          if (params["craftGuideParams"]) {
            for (let i = 0; i < params["craftGuideParams"].length; i++) {
              params["craftGuideParams"][i]["params"] = JSON.stringify(params["craftGuideParams"][i]["params"]);
            }
          }
          return this.http
            .post("/web/manage/craft/guide/create", params)
            .then((response) => {
              this.yt.isShowEditDialog = false;
              this.yt.get(1);
            })
            .catch((error) => {
              this.$message.error(error);
            });
        }
      });
    },
    // 驳回
    turnDown(id) {
      return this.http
        .get("/web/manage/craft/guide/reject?id=" + id)
        .then((res) => {
          this.yt.get(1);
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    // 批准
    approve(id) {
      return this.http
        .get("/web/manage/craft/guide/approve?id=" + id)
        .then((res) => {
          this.yt.get(1);
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
  },
};
</script>
